import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const logExchangeAgentRecommendationOutcome = unaryRpc({
  name: "logExchangeAgentRecommendationOutcome" as const,
  input: z.object({
    agentType: z.enum(["variant", "advanced", "guidance"]),
    recommendationAccepted: z.boolean(),
  }),
  output: z.object({}),
});
